import { createContext, useContext } from 'react';

export const SettingsContext = createContext({
  imageSearchPageSize: 10,
});

export const useSettings = () => useContext(SettingsContext);
